import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { campaignOne } from "../../store/campaign/actions";
export var GetCampaignOne = function (trigger, id) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseGetOneCampaign: (_a = state.Campaign.responseGetOneCampaign) === null || _a === void 0 ? void 0 : _a.data,
            errorGetOneCampaign: state.Campaign.errorGetOneCampaign,
            loadingGetOneCampaign: state.Campaign.loadingGetOneCampaign,
        });
    }), responseGetOneCampaign = _a.responseGetOneCampaign, errorGetOneCampaign = _a.errorGetOneCampaign, loadingGetOneCampaign = _a.loadingGetOneCampaign;
    useEffect(function () {
        if (trigger) {
            dispatch(campaignOne({
                id: id,
            }));
        }
    }, [trigger, id]);
    return {
        responseGetOneCampaign: responseGetOneCampaign,
        errorGetOneCampaign: errorGetOneCampaign,
        loadingGetOneCampaign: loadingGetOneCampaign,
    };
};
